import React from 'react';
import Details from './Details';
import TextBox from './TextBox';

const AdditionalData = ({ data }) => {
	const dt = data.additional_data;
	const titleList = {
		data_types: "Data types",
		jurisdictions: "Jurisdiction specific results",
		type_of_rules: "Type of rules"
	}
	return (
		<>
			<Details classList="text-black log-text" data={data} />
			<div className="flex flex-col gap-8 pl-6 mt-6">
				{
					Object.keys(titleList).map(key =>
						dt[key].length > 0 && (
							<div key={key} name={key} className="flex gap-1">
								<h5 className="text-article whitespace-nowrap font-medium relative text-black before:w-3 before:h-3 before:bg-primary before:rounded-full before:absolute before:top-1.5 before:-left-6">
									{titleList[key]}:
								</h5>
								<div>
									<TextBox initialText={dt[key].join(", ")} />
								</div>
							</div>
						)
					)
				}
			</div>
		</>
	)
}

export default AdditionalData;